// Shared complexity color vocabulary for the practice-problems experiment, so the header's progress
// track and the Skill Challenge criteria pill cannot drift apart. Kept out of the component files
// because tests that mock a component would otherwise blank these tokens for every other consumer.

type Complexity = '1' | '2' | '3';

export interface ComplexityStyle {
  label: string;
  badge: string;
  dot: string;
  halo: string;
}

export const COMPLEXITY_STYLES: Record<Complexity, ComplexityStyle> = {
  '1': {
    label: 'EASY',
    badge: 'tw-bg-yellow-50 tw-text-amber-500',
    dot: 'tw-bg-yellow-500',
    halo: 'tw-bg-yellow-50',
  },
  '2': {
    label: 'MEDIUM',
    badge: 'tw-bg-orange-200 tw-text-orange-500',
    dot: 'tw-bg-orange-500',
    halo: 'tw-bg-orange-200',
  },
  '3': {
    label: 'HARD',
    badge: 'tw-bg-pink-100 tw-text-red-600',
    dot: 'tw-bg-red-400',
    halo: 'tw-bg-pink-100',
  },
} as const;

// Items whose Learnosity tags are missing or hold an unexpected complexity value still get a
// segment, rendered neutral, so the track keeps matching the number of problems.
const NEUTRAL_STYLE: ComplexityStyle = {
  label: '',
  badge: 'tw-bg-neutral-100 tw-text-neutral-700',
  dot: 'tw-bg-neutral-400',
  halo: 'tw-bg-neutral-100',
} as const;

const isComplexity = (value: string | undefined): value is Complexity =>
  value === '1' || value === '2' || value === '3';

export const getComplexityStyle = (complexity: string | undefined): ComplexityStyle =>
  isComplexity(complexity) ? COMPLEXITY_STYLES[complexity] : NEUTRAL_STYLE;
